import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid2, IconButton, InputAdornment, InputLabel, snackbarClasses, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import MUIButton from "../../reusable_components/components/MUIButton";
import { useContext, useEffect, useState } from "react";
import { useDeleteCategoryByIdMutation, useDeleteKeywordsByIdMutation, useGetAllCategoriesWithKeywordsQuery, useGetCategoriesKeywordsQuery, useKeywordCategoryUpdateMutation, useSaveCategoryNameMutation, useSaveKeywordsMutation, useUpdateKeywordMutation, useViewKeywordsMutation, useViewKeywordsQuery } from "../../redux/Keywords/Keywords.api";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import CloseIcon from '@mui/icons-material/Close';
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import DeleteOutlineTwoToneIcon from '@mui/icons-material/DeleteOutlineTwoTone';
import Dropdown from "../../reusable_components/components/Dropdown";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '../../assets/deleteIcon.png';
import AddIcon from '@mui/icons-material/Add';
import './Keywords.css'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Loader from "../../reusable_components/components/Loader";

const Keywords = () => {

    const theme = useTheme()
    const isMediumScreen = useMediaQuery(theme.breakpoints.up('lg'))

    const { Snackbar } = useContext(SnackbarContext)
    const [keywordList, setKeywordList] = useState([]);
    const [keywordName, setKeywordName] = useState("")
    const [keywordId, setKeywordId] = useState()

    const [addOpen, setOpen] = useState(false);
    const [updateOpen, setUpdateOpen] = useState(false)
    const [addCategoryDialogOpen, SetAddCategoryDialogOpen] = useState(false)
    const [deleteCategoryOpen, setCategoryDeleteOpen] = useState(false)
    const [deleteKeywordDialogOpen, setDeleteKeywordDialogOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        setUpdateOpen(false)
        SetAddCategoryDialogOpen(false)
        setDeleteKeywordDialogOpen(false)
    }

    const handleAddDialogOpen = () => {
        setCategoryId(null);
        setOpen(true)
    }

    const handleAddCategoryOpen = () => {
        SetAddCategoryDialogOpen(true)
    }




    // const [selectedCategory, setSelectedCategory] = useState([])
    const [selectedCategory, setSelectedCategory] = useState([]);

    const handleUpdateDialogOpen = (category) => {
        setUpdateOpen(true);
        setSelectedCategory([category]); // Make sure it's always an array

    };

    // UseEffect to log or perform actions when selectedCategory changes
    useEffect(() => {
        if (selectedCategory) {
        }
    }, [selectedCategory]);


    // APIs
    const { data: viewKeywordsList, refetch } = useGetAllCategoriesWithKeywordsQuery();
    const { data: categoryList, refetch: CategoryRefecth } = useGetCategoriesKeywordsQuery();
    const [saveKeywords] = useSaveKeywordsMutation();
    const [deleteKeywordsById] = useDeleteKeywordsByIdMutation()
    const [updateKeyword] = useUpdateKeywordMutation()
    const [deleteCategoryById] = useDeleteCategoryByIdMutation()
    const [saveCategoryName] = useSaveCategoryNameMutation()
    const [dragKeywordUpdate] = useKeywordCategoryUpdateMutation()

    const handleOpen = () => {
        setOpen(true)
    }

    const handleCategoryId = (value) => {
        setCategoryId(value)
    }

    // Helper function to split array into n equal parts
    const chunkArray = (arr, numChunks) => {
        const result = [];
        const chunkSize = Math.ceil(arr.length / numChunks); // Distribute keywords evenly across columns
        for (let i = 0; i < numChunks; i++) {
            result.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
        }
        return result;
    };

    // Create 4 equal columns
    const keywordColumns = chunkArray(keywordList?.response || [], 4);

    const getKeywordName = (e) => {
        setKeywordName(e.target.value)

    }

    const handleAddKeyword = async () => {
        try {
            const payload = {
                categoryId: categoryId,
                KeywordName: keywordName,
            };
            const response = await saveKeywords(payload).unwrap();
            Snackbar(response?.data?.error_message || response?.response?.message, 'success');
            handleClose(); // Close the dialog box

        } catch (error) {
            Snackbar("Network error", 'error');
        }
    };

    const handleUpdateOpen = (keyword) => {
        setOpen(true)
        setKeywordName(keyword.keywordName)
        setKeywordId(keyword.KeywordId)
    }



    const [modifiedFields, setModifiedFields] = useState([])


    const handleUpdateCategory = (e) => {
        setCategoryname(e.target.value)
    }

    const handleGetUpdatedKeyNames = (event, categoryIndex, keywordIndex) => {
        const value = event.target.value;

        const updatedCategories = [...selectedCategory];

        const updatedSkills = updatedCategories[categoryIndex].Skills.map((keyword, index) => {
            if (index === keywordIndex) {
                return {
                    ...keyword,
                    KeywordName: value
                };
            }
            return keyword;  // Return other keywords unchanged
        });

        updatedCategories[categoryIndex] = {
            ...updatedCategories[categoryIndex],
            Skills: updatedSkills
        };

        setSelectedCategory(updatedCategories);
        setModifiedFields((prev) => new Set(prev).add(keywordIndex));
    };

    const handleKeywordUpdate = async () => {
        try {
            const { CategoryId, CategoryName } = selectedCategory[0];
            const Skills = selectedCategory[0]?.Skills?.map((item) => item) || []

            const selectedIndices = [...modifiedFields];
            const selectedSkills = selectedIndices?.map(index => Skills[index]);

            const payload = {
                CategoryId,
                CategoryName,
                Skills: selectedSkills?.map((keyword) => ({
                    KeywordId: keyword.KeywordId,
                    KeywordName: keyword.KeywordName
                }))
            }
            const response = await updateKeyword(payload)?.unwrap();
            if (response?.status === 200) {
                Snackbar(response?.response?.message, 'success');
            } else if (response?.status === "error") {
                Snackbar(response?.data?.error_message, 'error')
            } else {
                Snackbar('Keywords Update failed', 'error')
            }
            handleClose();

        } catch (error) {
            Snackbar("Network error", 'error');
        }
    }
    const handleDleteDialogOpen = (data, keyword) => {
        setDeleteKeywordDialogOpen(true)
        setCategoryId(data?.CategoryId)
        setKeywordId(keyword?.KeywordId)
    }

    const deleteKeyword = async () => {
        try {
            const payload = {
                deleteById: keywordId,
                categoryId: categoryId
            }
            const response = await deleteKeywordsById(payload).unwrap()
            setDeleteKeywordDialogOpen()
            setUpdateOpen()

            if (response?.data?.error_code === '32' || response?.data?.error_code === '40') {
                Snackbar(response?.data?.error_message, 'error')
            } else {
                Snackbar(response?.response?.message, 'success')
            }


        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const [categoryName, setCategoryname] = useState("")
    const handleAddCategory = (e) => {
        setCategoryname(e.target.value)
    }
    const saveNewCategory = async () => {
        if (categoryName.length >= 1) {
            try {
                const payload = {
                    categoryName: categoryName
                };

                const response = await saveCategoryName(payload).unwrap()
                SetAddCategoryDialogOpen()
                setCategoryname('')
                if (response?.data?.error_code === "3") {
                    Snackbar(response?.data?.error_message, 'error')
                } else {
                    Snackbar(response?.response?.message, 'success')
                }

            } catch (error) {
                Snackbar("Network error", 'error')
            }
        }
    }

    const [categoryId, setCategoryId] = useState("")

    const handleDeleteDialogOpen = (category) => {
        setCategoryDeleteOpen(true)
        setCategoryId(category.CategoryId)
    }

    const deleteCategory = async () => {
        try {
            const payload = {
                categoryNameId: categoryId
            }
            const response = await deleteCategoryById(payload).unwrap()
            Snackbar(response?.response?.message || response?.data?.error_message, 'success')
            setCategoryDeleteOpen()

        } catch (error) {
            Snackbar("Netwrok error", 'error')
        }
    }

    useEffect(() => {
        refetch()
        CategoryRefecth()
    }, [addOpen, updateOpen, deleteCategoryOpen, addCategoryDialogOpen,])


    const [showTableLoader, setShowTableLoader] = useState('')

    const [draggingKeywordId, setDragginKeywordId] = useState('')
    const [draggingCategoryId, setDragginCategoryId] = useState('')

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDragStart = (e, skill, categoryId) => {
        setDragginKeywordId(skill?.KeywordId)
        setDragginCategoryId(categoryId)
        e.dataTransfer.effectAllowed = "move";
    }

    const handleDrop = async (e, category) => {
       
        if (draggingCategoryId !== category?.CategoryId) {
            try {
                const payload = {
                    keywordId: draggingKeywordId,
                    categoryId: category?.CategoryId
                }
                setShowTableLoader(true)
                const response = await dragKeywordUpdate(payload)?.unwrap()
                setShowTableLoader(false)
                Snackbar(response?.response?.message, 'success')
                refetch()

            } catch (error) {
                Snackbar('Network error', 'error')
            }
        }else {
            return;
        }
    }


    return (
        <Box className="container">
            {
                showTableLoader ? <Loader /> : ''
            }
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', width: '95%' }}>
                <Typography className="title" >Keywords</Typography>
                <Box sx={{ display: 'flex', gap: '20px', }}>
                    <MUICancelButton startIcon={<AddIcon />} sx={{ backgroundColor: "#7F56D9", color: 'white', padding: '10px' }}
                        onClick={handleAddCategoryOpen}
                        title="Add Category">
                    </MUICancelButton>

                    <MUICancelButton startIcon={<AddIcon />} sx={{ backgroundColor: "#7F56D9", color: 'white', padding: '10px' }}
                        onClick={handleAddDialogOpen}
                        title="Add Keywords">
                    </MUICancelButton>

                </Box>
            </Box>

            <Grid2
                container
                spacing={2}
                sx={{
                    marginTop: '30px',
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    '@media (max-width: 900px)': {
                        justifyContent: 'right',
                    },
                    '@media (max-width: 600px)': {
                        width: 'center',
                    },
                }}
            >
                {viewKeywordsList?.map((category) => (
                    <Grid2
                        key={category.CategoryId}
                        sx={{
                            '@media (max-width: 900px)': {
                                width: '45%',
                            },
                            '@media (max-width: 600px)': {
                                width: '100%',
                            },
                            display: 'flex',
                            flexDirection: 'column',
                            width: '23%',
                            border: '1px solid #E9EAEB',
                            borderRadius: '12px',
                            padding: '5px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',

                        }}
                    >
                        <Table
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => handleDrop(e, category)}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Typography sx={{ width: '100%', fontWeight: 500, color: '#181D27' }}>{category?.CategoryName}</Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <IconButton>
                                                <Tooltip
                                                    slotProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: "#0A0D12",
                                                                borderRadius: '8px',
                                                                padding: '8px 12px',
                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                            }
                                                        }
                                                    }}
                                                    placement="top" title="Edit" sx={{ color: '#A4A7AE' }}>
                                                    <EditOutlinedIcon onClick={(e) => handleUpdateDialogOpen(category)} />
                                                </Tooltip>
                                            </IconButton>
                                            {/* <IconButton>
                                                <Tooltip
                                                    slotProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: "#0A0D12",
                                                                borderRadius: '8px',
                                                                padding: '8px 12px',
                                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)'
                                                            }
                                                        }
                                                    }}
                                                    placement="top" title="Delete" sx={{ color: '#A4A7AE' }}>
                                                    <DeleteOutlineTwoToneIcon onClick={(e) => handleDeleteDialogOpen(category)} />
                                                </Tooltip>
                                            </IconButton> */}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <Box className="scrollable-box"
                                sx={{
                                    height: '310px',
                                    overflowY: 'auto',
                                }}
                            >
                                <TableBody>
                                    {category?.Skills?.map((skill, index) => (
                                        <TableRow
                                            key={skill.KeywordId}
                                            draggable
                                            onDragStart={(e) => handleDragStart(e, skill, category.CategoryId)}
                                            onDragOver={handleDragOver}
                                            sx={{
                                                cursor: 'grab',
                                                '&:active': {
                                                    cursor: 'grabbing'
                                                },
                                            }}
                                        >
                                            <TableCell
                                                sx={{
                                                    padding: '8px 14px',
                                                    color: '#535862',
                                                    width: '100vw',
                                                    borderBottom: index === category.Skills.length - 1 ? 'none' : '1px solid #E9EAEB',  // Remove border from the last cell in the row
                                                }}
                                            >
                                                {skill?.KeywordName}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Box>
                        </Table>
                    </Grid2>
                ))}
            </Grid2>

            {/* Add keywords dialog box */}
            <Grid2>
                <Dialog
                    open={addOpen}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        '& .MuiDialog-paper': {
                            minHeight: '45vh',
                            minWidth: '25vw',
                            borderRadius: '20px',
                            overflow: 'auto',
                        },
                        marginLeft: '70px',
                    }}
                >
                    <DialogTitle >
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <Typography className="title">Add Keywords</Typography>
                            <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose}></CloseIcon>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <Typography>Category<span style={{ color: 'red', }}>*</span></Typography>
                        <Dropdown
                            style={{ marginTop: '10px' }}  // Use style for inline styles
                            placeholder="Choose a category"
                            labelKey="CategoryName"
                            valueKey="Id"
                            value={categoryId}
                            onChange={(value) => handleCategoryId(value)}
                            options={categoryList?.response || []}
                        />
                        <textarea
                            className="custom-textarea"
                            onChange={getKeywordName}
                        />
                        <Grid2 sx={{ marginTop: '30px', display: "flex" }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', gap: '10px', }}>
                                <MUICancelButton onClick={handleClose} title='Cancel' sx={{ width: '50%' }}></MUICancelButton>
                                <MUICancelButton title="Confirm" onClick={handleAddKeyword} sx={{ backgroundColor: '#7F56D9', color: '#FFFFFF', width: '50%' }}></MUICancelButton>
                            </Box>
                        </Grid2>
                    </DialogContent>
                </Dialog>
            </Grid2>

            {/* Edit and delete keywords dialog box  */}
            <Grid2>
                <Dialog
                    open={updateOpen}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        '& .MuiDialog-paper': {
                            minHeight: '65vh',
                            minWidth: '23vw',
                            borderRadius: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                        },
                        marginLeft: '70px',
                    }}
                >
                    {selectedCategory?.map((data, categoryIndex) => (
                        <div key={categoryIndex} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <DialogTitle>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}> Edit {data?.CategoryName}</Typography>
                                    <CloseIcon sx={{ cursor: 'pointer', color: '#717680' }} onClick={handleClose}></CloseIcon>
                                </Box>
                            </DialogTitle>

                            <DialogContent
                                className="scrollable-box"
                                sx={{
                                    flex: 1,
                                    maxHeight: '52vh',
                                    overflowY: 'auto',
                                }}
                            >
                                <Box rowGap={1} sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <TextField
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                borderRadius: '7px',
                                                height: '35px',
                                                color: '#717680',
                                            },
                                            backgroundColor: '#FAFAFA'
                                        }}
                                        value={data?.CategoryName}
                                    />

                                    {data?.Skills?.map((keyword, keywordIndex) => (
                                        <TextField
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    borderRadius: '7px',
                                                    height: '35px',
                                                    color: '#717680',
                                                },
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <Tooltip title="Delete"
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    backgroundColor: "#0A0D12",
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <InputAdornment position="end">
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <img src={DeleteIcon} onClick={(e) => handleDleteDialogOpen(data, keyword)} style={{ width: '15px', height: '15px', filter: 'grayscale(100%)', cursor: 'pointer' }} />
                                                            </div>
                                                        </InputAdornment>
                                                    </Tooltip>
                                                ),
                                            }}
                                            key={keyword?.KeywordId}
                                            value={keyword?.KeywordName}
                                            onChange={(e) => handleGetUpdatedKeyNames(e, categoryIndex, keywordIndex)} // Pass category and keyword index

                                        />
                                    ))}
                                    <Typography
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            color: '#6941C6',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        <AddIcon /> Add Keywords
                                    </Typography>
                                </Box>
                            </DialogContent>
                        </div>
                    ))}
                    <DialogActions sx={{ marginTop: 'auto', padding: '16px' }}>
                        <Grid2 item sx={{ display: 'flex', justifyContent: 'center', width: '100%', gap: '10px' }}>
                            <MUICancelButton
                                title="Cancel"
                                sx={{ width: '45%' }}
                                onClick={() => setUpdateOpen(false)}
                            />
                            <MUIButton
                                title="Confirm"
                                sx={{
                                    backgroundColor: '#7F56D9',
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    width: '45%',
                                }}
                                onClick={handleKeywordUpdate}
                            />
                        </Grid2>
                    </DialogActions>
                </Dialog>

            </Grid2>


            {/* dialogg box for delete the dialog box */}
            <Grid2 item>
                <Dialog
                    open={deleteKeywordDialogOpen}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="xs"
                    sx={{
                        "& .MuiDialog-paper": {
                            width: '90%',
                            maxWidth: '550px',
                            height: 'auto',
                            borderRadius: '15px'
                        },
                    }}
                >
                    <DialogContent>
                        <DialogContentText>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '7px' }}>
                                <div style={{ backgroundColor: '#FEE4E2', borderRadius: '40px', height: '40px', width: '45px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={DeleteIcon} style={{ width: '20px', height: '20px' }} />
                                </div>

                                <div>
                                    <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '17px' }}>Delete keyword ?</Typography>
                                    <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>
                                        Are you sure you want to delete this Keyword? This action cannot be undone.
                                    </Typography>
                                </div>
                            </div>
                            <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <MUICancelButton title='Cancel' onClick={() => setDeleteKeywordDialogOpen(false)} />
                                <MUIButton title='Delete' onClick={deleteKeyword} sx={{ backgroundColor: '#D92D20', borderRadius: '10px', cursor: 'pointer' }} />
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </Grid2>



            {/* Delete category  Dilaog box */}
            <Grid2 item>
                <Dialog
                    open={deleteCategoryOpen}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="xs"
                    sx={{
                        "& .MuiDialog-paper": {
                            width: '90%',
                            maxWidth: '550px',
                            height: 'auto',
                            borderRadius: '15px'
                        },
                    }}
                >
                    <DialogContent>
                        <DialogContentText>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '7px' }}>
                                <div style={{ backgroundColor: '#FEE4E2', borderRadius: '40px', height: '40px', width: '45px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={DeleteIcon} style={{ width: '20px', height: '20px' }} />
                                </div>

                                <div>
                                    <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '17px' }}>Delete keywords category?</Typography>
                                    <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>
                                        Are you sure you want to delete this category? This action cannot be undone.
                                    </Typography>
                                </div>
                            </div>
                            <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <MUICancelButton title='Cancel' onClick={() => setCategoryDeleteOpen(false)} />
                                <MUIButton title='Delete' onClick={deleteCategory} sx={{ backgroundColor: '#D92D20', borderRadius: '10px', cursor: 'pointer' }} />
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </Grid2>

            {/* Add Category dialog box */}
            <Grid2>
                <Dialog
                    open={addCategoryDialogOpen}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        '& .MuiDialog-paper': {
                            minHeight: '40vh',
                            minWidth: '25vw',
                            borderRadius: '20px',
                            overflow: 'auto',
                        },
                        marginLeft: '70px',
                    }}
                >
                    <DialogTitle >
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <Typography className="title">Create Category</Typography>
                            <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose}></CloseIcon>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <textarea
                            className="custom-textarea-2"
                            value={categoryName}
                            onChange={handleAddCategory}

                        />
                        <Grid2 sx={{ marginTop: '30px', display: "flex" }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', gap: '10px', }}>
                                <MUICancelButton onClick={handleClose} title='Cancel' sx={{ width: '50%' }}></MUICancelButton>
                                <MUICancelButton title="Confirm" onClick={saveNewCategory} sx={{ backgroundColor: '#7F56D9', color: '#FFFFFF', width: '50%' }}></MUICancelButton>
                            </Box>
                        </Grid2>
                    </DialogContent>
                </Dialog>
            </Grid2>

        </Box >
    );
};

export default Keywords;
